<template>
  <div id="app">
    <Index />
  </div>
</template>

<script>
import Index from './components/Index.vue'

export default {
  name: 'App',
  components: {
    Index
  }
}
</script>

<style lang="scss">
body {
  font-family: poppins,sans-serif;
  font-weight: 400;
  font-style: normal;
}
</style>
